import i18n from "i18n";

// Moduli acquistabili da ogni ristorante: il codice corrisponde a quello del backend.
// Etichette e suggerimenti sono letti al momento dell'uso (getter), cosi' seguono la lingua corrente.
const mod = (code) => ({
  code,
  get label() {
    return i18n.t(`common:modules.${code}.label`);
  },
  get hint() {
    return i18n.t(`common:modules.${code}.hint`);
  },
});

export const MODULES = [
  mod("wine"),
  mod("food"),
  mod("beer"),
  mod("beverages"),
  mod("waters"),
  mod("drinks"),
  mod("spirits"),
  mod("mixers"),
  mod("bookings"),
  mod("orders"),
];
export const ALL_MODULE_CODES = MODULES.map((m) => m.code);
// Un nuovo cliente parte senza moduli: l'admin spunta uno per uno quelli venduti.

export const moduleLabel = (code) =>
  MODULES.find((m) => m.code === code)?.label || code;
